import createReducer from "./createReducer";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";

import { QA_PANEL_ACTIONS } from "./actions/QA";
import { tellSentry } from "utils/Rave";
import { QATerritories, SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { escapeUnderscoreForAPI } from "utils/common";

const initialQAStore = {
	success: true,
	items: [],

	totalPages: 1,
	totalItems: 0,

	hasErrorLoading: false,
	isLoaded: false,
};

const actionCreators = {
	loadQA,
};

const handlers = {
	[QA_PANEL_ACTIONS.FETCH_QA_LIST]: isLoadingQA,
	[QA_PANEL_ACTIONS.FETCH_QA_LIST_SUCCESS]: initQAList,
	[QA_PANEL_ACTIONS.FETCH_QA_LIST_ERROR]: errorQAList,

	[QA_PANEL_ACTIONS.ASSIGN_ACTION_SUCCESS]: updateLibraryList,
};


let reducerConfig = {
	typeRoot: "QA",
	initialState: initialQAStore,
	actionTypes: QA_PANEL_ACTIONS,
	actionCreators,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "oldestSubmitDate:DESC" });
reducerConfig = addColumnFilters(reducerConfig, {
	oldestSubmitDate:{
		name:"oldestSubmitDate",
		type:"Date",
		displayName:"Submitted Date",
	},
	submitted:{
		name:"submitted",
		type:"Number",
		displayName:"Submitted",
	},
	pendingApproval: {
		name: "pendingApproval",
		type: "Number",
		displayName: "Approving",
	},
	qaLocationId: {
		name: "qaLocationId",
		type: "Checkbox",
		displayName: "Department",
		options:QATerritories.map(v => v.label),
		dictionaryName: "qaLocationId",
	},
	submittedBy: {
		name: "submittedBy",
		type: "String",
		displayName: "Submitted By",
	},
});

export function loadQA(cancelToken){
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo = {} } = state.qa;
		const params = { ...filterInfo };

		if (params.searchTerm) {
			params.searchTerm = escapeUnderscoreForAPI(filterInfo.searchTerm);
		}

		return dispatch({
			type: QA_PANEL_ACTIONS.FETCH_QA_LIST,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `ui/creative-libraries/creative-status/submitted-ads`,
				params,
				success: QA_PANEL_ACTIONS.FETCH_QA_LIST_SUCCESS,
				error: QA_PANEL_ACTIONS.FETCH_QA_LIST_ERROR,
				cancel: QA_PANEL_ACTIONS.FETCH_QA_LIST_CANCEL,
				cancelToken,
			},
		});
	};
}

export function assignLibrary(userInfo, libraryIds){
	return (dispatch) => {
		let userId = null;

		if(userInfo){
			userId = userInfo.id;
		}

		return dispatch({
			type:QA_PANEL_ACTIONS.ASSIGN_ACTION_AJAX,
			payload:{ libraryIds, userInfo },
			AJAX:{
				url: `ui/creative-libraries/creative-status/${libraryIds.join(",")}/assignee`,
				method:"post",
				data:{ userId },
				success:QA_PANEL_ACTIONS.ASSIGN_ACTION_SUCCESS,
				error:QA_PANEL_ACTIONS.ASSIGN_ACTION_ERROR,
			},
		});
	};
}

function isLoadingQA(state, action){
	return {
		...state,
		isLoaded: false,
	};
}

function initQAList(state, action){
	let { data } = action.payload
		, qaList = data.items.map((qaItem) => {
			let department = QATerritories.find(v => v.value === qaItem.qaLocationId);

			if(!department){
				tellSentry(`Unknown Department ID - ${qaItem.qaLocationId}`);
				department = { label:qaItem.qaLocationId, value:qaItem.qaLocationId };
			}

			return {
				...qaItem,
				department,
			};
		});

	return {
		...state,
		...data,
		items:qaList,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

function errorQAList(state, action){
	return {
		...state,
		isLoaded: true,
		hasErrorLoading: true,
	};
}

function updateLibraryList(state, action){
	let { original } = action.payload;

	return {
		...state,
		items:state.items.map((v) => {
			if(original.libraryIds.includes(v.id)){
				return {
					...v,
					assignee:original?.userInfo?.userName || "",
				};
			}
			return v;
		}),
		isLoaded:true,
		hasErrorLoading:false,
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const QA = reducerConfig.actionCreators;
export const PRIVATE = {
	...reducerConfig.handlers,
};
